'use es6';

import { memo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
function CalleeSelectMessage({
  message,
  isError,
  isHelp
}) {
  return /*#__PURE__*/_jsx(Text, {
    paddingInline: "300",
    paddingBlock: "500",
    marginBlockEnd: isHelp ? '300' : undefined,
    color: isError ? 'text-alert-default' : isHelp ? 'text-core-subtle' : undefined,
    children: message
  });
}
export default /*#__PURE__*/memo(CalleeSelectMessage);